import { NgModule } from '@angular/core';
import { DateAdapter, MatAutocompleteModule, MatButtonModule, MatButtonToggleModule, MatCardModule, MatCheckboxModule,
	MatChipsModule, MatDatepickerModule, MatDialogModule, MatExpansionModule, MatIconModule, MatInputModule, MatMenuModule,
	MatPaginatorModule, MatProgressSpinnerModule, MatRadioModule, MatSelectModule, MatSidenavModule, MatSliderModule,
	MatSlideToggleModule, MatTableModule, MatTabsModule, MatToolbarModule, MatTooltipModule, MAT_DATE_FORMATS, MatProgressBarModule } from '@angular/material';
import { AzcDateAdapter } from './common/datetime/azc-date-adapter';
import { AzcDateFormat } from './common/datetime/azc-date-format.const';

const materialModules = [
	MatProgressBarModule,
	MatTableModule,
	MatIconModule,
	MatTabsModule,
	MatToolbarModule,
	MatSidenavModule,
	MatButtonModule,
	MatInputModule,
	MatDatepickerModule,
	MatPaginatorModule,
	MatChipsModule,
	MatSelectModule,
	MatTooltipModule,
	MatAutocompleteModule,
	MatCardModule,
	MatProgressSpinnerModule,
	MatMenuModule,
	MatDialogModule,
	MatSliderModule,
	MatSlideToggleModule,
	MatButtonToggleModule,
	MatCheckboxModule,
	MatExpansionModule,
	MatRadioModule
];

@NgModule({
	imports: materialModules,
	exports: materialModules,
	providers: [
		{ provide: MAT_DATE_FORMATS, useValue: AzcDateFormat },
		{ provide: DateAdapter, useClass: AzcDateAdapter },
	]
})
export class AzcMaterialModule { }
